var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCancelSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18a8.96 8.96 0 0 0 5.633-1.992l7.658 7.697a1 1 0 0 0 1.418-1.411l-7.668-7.707A8.94 8.94 0 0 0 18 9c0-4.963-4.037-9-9-9S0 4.037 0 9c0 4.962 4.037 9 9 9M9 2c3.859 0 7 3.14 7 7s-3.141 7-7 7-7-3.141-7-7 3.14-7 7-7M-36.517 1.627l10.292-10.293a.999.999 0 1 0-1.414-1.414L-37.932.213-48.225-10.08a.999.999 0 1 0-1.414 1.414l10.292 10.293-10.292 10.293a.999.999 0 1 0 1.414 1.414l10.293-10.293 10.293 10.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414zM5.249 17.458l-1.973 2.007-1.973-2.007-1.184 1.204 1.973 2.007-1.973 2.008 1.184 1.204 1.973-2.007 1.973 2.007 1.184-1.204-1.973-2.008 1.973-2.007z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCancelSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cancel_search.svg";